import React from 'react';
import PropTypes from 'prop-types';

const Strings = require('../../../../app/shared/Strings');
import WarningBox from './WarningBox';

const propTypes = {};
const defaultProps = {};

function MaintenanceWarning(props) {
    return (
        <WarningBox>{Strings['en'].maintenance.DEFAULT_MESSAGE}</WarningBox>
    );
}

MaintenanceWarning.propTypes = propTypes;
MaintenanceWarning.defaultProps = defaultProps;

export default MaintenanceWarning;